import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Typography } from '../styled'
import theme from '../../constants/theme'
import FullLogo from '../../assets/logos/full-logo.png'
import ClockOutline from '../../assets/svgs/ClockOutline'
import { formatTime, getAssessmentTypeLabel } from './helpers'
import { StickyHeader, TimerPill, TimerText } from './styles'

function AssessmentHeader({ assessment, timeLeft }) {
  const { t } = useTranslation()

  return (
    <StickyHeader>
      <div className="container d-flex justify-content-between align-items-center">
        <img src={FullLogo} width="120px" alt="logo" />
        <div className="text-center d-flex flex-column align-items-center">
          <Typography bold size="16px" color={theme.talentinoBlack}>
            {assessment?.name}
          </Typography>{' '}
          <Typography size="10px" color={theme.talentinoSecondaryGray}>
            {assessment?.questions?.length} {t('interview.questions')} ·{' '}
            {getAssessmentTypeLabel(t, assessment?.assessmentType)}
          </Typography>
        </div>
        <TimerPill danger={timeLeft < 60}>
          <ClockOutline width={16} height={16} />
          <TimerText>{formatTime(timeLeft)}</TimerText>
        </TimerPill>
      </div>
    </StickyHeader>
  )
}

AssessmentHeader.propTypes = {
  assessment: PropTypes.shape({
    name: PropTypes.string,
    assessmentType: PropTypes.string,
    questions: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  timeLeft: PropTypes.number,
}

export default AssessmentHeader
